import { wrapImageOverlayer } from './Overlayer';
import { requestCutoutImageFunction } from './requestCutoutImageFunction';

export default {
  type: 'removeBackground',
  setup: async ({ app }) => {
    // 注册一个新的图片工具类型（往顶部工具栏添加按钮）
    app.extension.registerElementTool({
      name: 'removeBackground',
      // label: '去背景新',
      icon: '',
      handler: (props) => {
        const { selection } = props;
        const id = selection[0];
        const elements = app.store.getProjectState('elements');
        const aimElement = app.helpers.element.findElement(elements, id);
        requestCutoutImageFunction(aimElement);
      },
    });

    // 注册一个overlayer组件，用于转圈圈
    app.extension.wrapElement('image', {
      overlayer: wrapImageOverlayer,
    });
  },
};
